export default __webpack_public_path__ + "static/media/std-icon.8822e1fb.svg";